export function parseWorkflowAuditDetails(details: string | undefined | null): { trigger?: string } {
  if (!details?.trim()) return {};
  try {
    const o = JSON.parse(details) as Record<string, unknown>;
    const trigger = typeof o.trigger === 'string' ? o.trigger : undefined;
    return { trigger };
  } catch {
    return {};
  }
}

export function workflowActionLabel(action: string): string {
  switch (action) {
    case 'WorkflowStarted':
      return 'Workflow iniciado';
    case 'WorkflowCancelled':
      return 'Workflow cancelado';
    case 'ResponsibleChanged':
      return 'Responsáveis da etapa alterados';
    case 'SendForReview':
      return 'Enviado para revisão';
    case 'Approve':
      return 'Aprovado';
    case 'Reject':
      return 'Rejeitado';
    case 'Publish':
      return 'Publicado';
    case 'Archive':
      return 'Arquivado';
    case 'SendForSignature':
      return 'Enviado para assinatura';
    case 'SignatureInvitesSent':
      return 'Convites de assinatura enviados';
    case 'SignatureSigned':
      return 'Assinatura registrada';
    case 'SignatureRejected':
      return 'Assinatura recusada';
    case 'SignaturesCompleted':
      return 'Todas as assinaturas concluídas';
    case 'SignatureCancelled':
      return 'Solicitação de assinatura cancelada';
    case 'Sign':
      return 'Assinado';
    case 'CompleteEdit':
      return 'Edição concluída';
    case 'Edit':
      return 'Nova versão / reativação';
    case 'Comment':
      return 'Comentário';
    case 'Save':
      return 'Salvo';
    case 'Delete':
      return 'Exclusão';
    default:
      return action || 'Ação';
  }
}

export type WorkflowActionTone = 'green' | 'red' | 'blue' | 'gray';

export function workflowActionTone(action: string): WorkflowActionTone {
  switch (action) {
    case 'WorkflowStarted':
      return 'blue';
    case 'WorkflowCancelled':
      return 'red';
    case 'ResponsibleChanged':
      return 'blue';
    case 'Approve':
    case 'Publish':
    case 'Sign':
    case 'SignatureSigned':
    case 'SignaturesCompleted':
      return 'green';
    case 'Reject':
    case 'SignatureRejected':
    case 'SignatureCancelled':
      return 'red';
    case 'SendForReview':
    case 'SendForSignature':
    case 'SignatureInvitesSent':
    case 'CompleteEdit':
    case 'Edit':
      return 'blue';
    case 'Archive':
      return 'gray';
    default:
      return 'gray';
  }
}
